import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 个人承租——个人承租分页
  getPersonLeasePage: `${baseUrl}/personLease/getPage`,

  // 个人承租——添加个人承租
  addPersonLease: `${baseUrl}/personLease/add`,

  // 个人承租——查询个人承租详情
  getPersonLeaseByCode: `${baseUrl}/personLease/getByCode`,

  // 个人承租——修改个人承租
  updatePersonLease: `${baseUrl}/personLease/update`,

  // 个人承租——删除个人承租
  delPersonLeaseByCodes: `${baseUrl}/personLease/delByCodes`,

  // 个人承租——个人承租列表
  getPersonLeaseList: `${baseUrl}/personLease/getList`,

  // 个人承租——分配房源
  allotPersonLeaseRoom: `${baseUrl}/personLease/allotRoom`,

  // 单位承租——单位承租分页
  getEnterpriseLeasePage: `${baseUrl}/enterpriseLease/getPage`,

  // 单位承租——添加单位承租
  addEnterpriseLease: `${baseUrl}/enterpriseLease/add`,

  // 单位承租——查询单位承租详情
  getEnterpriseLeaseByCode: `${baseUrl}/enterpriseLease/getByCode`,

  // 单位承租——修改单位承租
  updateEnterpriseLease: `${baseUrl}/enterpriseLease/update`,

  // 单位承租——删除单位承租
  delEnterpriseLeaseByCodes: `${baseUrl}/enterpriseLease/delByCodes`,

  // 单位承租——单位承租列表
  getEnterpriseLeaseList: `${baseUrl}/enterpriseLease/getList`,

  // 单位承租——分配房源
  allotEnterpriseLeaseRoom: `${baseUrl}/enterpriseLease/allotRoom`,

  // 获取房间列表
  getRoomInfoList: `${baseUrl}/roomInfo/getRoomInfoList`,

  // 房源解绑
  delLeaseRoomBindByCodes: `${baseUrl}/leaseRoomBind/delByCodes`,

  // 修改绑定房源数据
  updateLeaseRoomBind: `${baseUrl}/leaseRoomBind/update`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/LeaseManage.js